import React, { createContext, useContext, useState } from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'

const SnackbarContext = createContext()

export const useSnackbar = () => {
  const context = useContext(SnackbarContext)
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider')
  }
  return context
}

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info', // 'error', 'warning', 'info', 'success'
    autoHideDuration: 6000
  })

  const showSnackbar = (message, severity = 'info', autoHideDuration = 6000) => {
    setSnackbar({
      open: true,
      message,
      severity,
      autoHideDuration
    })
  }

  const hideSnackbar = () => {
    setSnackbar(prev => ({
      ...prev,
      open: false
    }))
  }

  const showError = (message, autoHideDuration = 6000) => {
    showSnackbar(message, 'error', autoHideDuration)
  }

  const showSuccess = (message, autoHideDuration = 6000) => {
    showSnackbar(message, 'success', autoHideDuration)
  }

  const showWarning = (message, autoHideDuration = 6000) => {
    showSnackbar(message, 'warning', autoHideDuration)
  }

  const showInfo = (message, autoHideDuration = 6000) => {
    showSnackbar(message, 'info', autoHideDuration)
  }

  const value = {
    showSnackbar,
    showError,
    showSuccess,
    showWarning,
    showInfo,
    hideSnackbar
  }

  return (
    <SnackbarContext.Provider value={value}>
      {children}
      <Snackbar 
          open={snackbar.open} 
          autoHideDuration={snackbar.autoHideDuration} 
          onClose={hideSnackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          style={{ marginTop: '160px' }}
        >
        <MuiAlert 
          onClose={hideSnackbar} 
          severity={snackbar.severity} 
          variant="filled"
          elevation={6}
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </SnackbarContext.Provider>
  )
} 